export function formatTime(
  timeInSeconds: number,
  precision = 0,
  includeHours = false,
) {
  const totalSeconds = Number(timeInSeconds);
  let hours = Math.floor(totalSeconds / 3600);
  let minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  let sec = Number(seconds.toFixed(precision));

  // Handle rounding up seconds and minutes
  if (sec >= 60) {
    minutes += 1;
    sec = 0;
  }
  if (minutes >= 60) {
    hours += 1;
    minutes = 0;
  }

  const pad = (num: number) => num.toString().padStart(2, "0");

  if (!includeHours || hours === 0) {
    if (precision === 0) {
      return `${minutes}:${pad(sec)}`;
    }
    return `${minutes}:${sec.toFixed(precision).padStart(2 + precision + 1, "0")}`;
  } else {
    if (precision === 0) {
      return `${hours}:${pad(minutes)}:${pad(sec)}`;
    }
    return `${hours}:${pad(minutes)}:${sec.toFixed(precision).padStart(2 + precision + 1, "0")}`;
  }
}
